export default __webpack_public_path__ + "static/media/nibib-logo.a2af079e.png";